export default (currency) => {
  let currencyObj = {
    prefix: "",
    suffix: "",
    symbol: ""
  }
  if (currency == "USD") {
    currencyObj.prefix = "$"
    currencyObj.symbol = "$"
  } else if (currency == "EUR") {
    currencyObj.prefix = "€"
    currencyObj.symbol = "€"
  } else if (currency == "JPY") {
    currencyObj.prefix = "JP¥"
    currencyObj.symbol = "¥"
  } else if (currency == "GBP") {
    currencyObj.prefix = "£"
    currencyObj.symbol = "£"
  } else if (currency == "AUD") {
    currencyObj.prefix = "$"
    currencyObj.symbol = "$"
  } else if (currency == "CAD") {
    currencyObj.prefix = "$"
    currencyObj.symbol = "$"
  } else if (currency == "CHF") {
    currencyObj.prefix = "fr."
    currencyObj.symbol = "fr."
  } else if (currency == "CNY") {
    currencyObj.prefix = "¥"
    currencyObj.symbol = "¥"
  } else if (currency == "HKD") {
    currencyObj.prefix = "$"
    currencyObj.symbol = "$"
  } else if (currency == "NZD") {
    currencyObj.prefix = "$"
    currencyObj.symbol = "$"
  } else if (currency == "AED") {
    currencyObj.prefix = "د.إ"
    currencyObj.symbol = "د.إ"
  } else if (currency == "INR") {
    currencyObj.prefix = "₹"
    currencyObj.symbol = "₹"
  } else if (currency == "SGD") {
    currencyObj.prefix = "$"
    currencyObj.symbol = "$"
  } else if (currency == "KRW") {
    currencyObj.prefix = "₩"
    currencyObj.symbol = "₩"
  }

  return currencyObj;
}